export enum EnumCRT
{
    SimplesNacional = 1,
    SimplesNacionalExcessoSublimite = 2,
    RegimeNormalPresumido = 3,
    RegimeNormalReal = 4,
    MEI = 5,
    NaoSeAplica = 9
}